import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { FinTSInstituteUpload } from './FinTSInstituteUpload';

/**
 * Page-Wrapper für /admin/fints-institutes — versteckte Admin-Seite zum
 * Pflegen des FinTS-Banken-Katalogs. Nicht im Standard-Menü, sondern
 * über /admin/dev (Developer-Hub) verlinkt.
 */
export const FinTSInstituteOverview: React.FC = () => (
  <Box sx={{ p: 2 }}>
    <Typography variant='h5' sx={{ mb: 1 }}>
      FinTS-Listen Management
    </Typography>
    <Alert severity='warning' sx={{ mb: 3 }}>
      Versteckter Admin-Bereich. Hochladen einer fehlerhaften Datei kann dazu
      führen, dass beim Konto-Anlegen-Dialog keine BLZ mehr erkannt wird. Im
      Zweifel die letzte funktionierende <code>fints.xlsx</code> bereithalten.
    </Alert>
    <FinTSInstituteUpload />
  </Box>
);
